import { render, staticRenderFns } from "./RencanaAksiCards.vue?vue&type=template&id=427e00b5&"
import script from "./RencanaAksiCards.vue?vue&type=script&lang=js&"
export * from "./RencanaAksiCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports